import IneligibleError from './IneligibleError';

export default IneligibleError;
